export default __webpack_public_path__ + "static/media/performancestrategy-fofac.5257c0dd.png";